"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRow = exports.StyledList = exports.StyledLabel = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _heading = _interopRequireWildcard(require("../../atoms/heading"));

var _label = _interopRequireDefault(require("../../atoms/label"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " 0;\n  ", ":first-child {\n    border-top: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          ", "\n          border-top: 1px solid ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  min-height:  ", ";\n  box-sizing: border-box;\n  padding-left: 8px;\n  ", "\n  &:hover {\n    ", "\n    background: ", ";\n  }\n\n  span {\n    line-height: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  ", "\n  border-bottom: 1px solid ", ";\n  ", " {\n    margin: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'list');
};

var StyledLabel = _styledComponents["default"].div(_templateObject(), _tokens.spacing.xsmall, ''
/* border-bottom: 1px solid ${colors.list.borderColor}; */
, function (props) {
  return getColors(props).borderColor;
}, _heading.StyledHeading[4]);

exports.StyledLabel = StyledLabel;

var StyledRow = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.height;
}, function (props) {
  return props.bordered ? (0, _styledComponents.css)(_templateObject3(), ''
  /* border-top: 1px solid ${colors.list.borderColor}; */
  , function (props) {
    return getColors(props).borderColor;
  }) : (0, _styledComponents.css)(_templateObject4());
}, ''
/* background: ${colors.list.backgroundHover}; */
, function (props) {
  return getColors(props).backgroundHover;
}, function (props) {
  return props.height;
});

exports.StyledRow = StyledRow;

var StyledList = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.lean ? _tokens.spacing.xxsmall : _tokens.spacing.large;
}, StyledRow);

exports.StyledList = StyledList;

var List = function List(props) {
  var onClick = function onClick() {
    return props.onChildSelection ? props.onChildSelection() : null;
  };

  var validChildren = _react["default"].Children.toArray(props.children).filter(function (child) {
    return child;
  });

  return _react["default"].createElement(StyledList, props, props.label && _react["default"].createElement(StyledLabel, {
    version: props.version
  }, _react["default"].createElement(_heading["default"], {
    size: 4
  }, props.label)), _react["default"].Children.map(validChildren, function (child) {
    return _react["default"].createElement(StyledRow, _extends({}, props, {
      onClick: onClick
    }), _react["default"].createElement(_label["default"], {
      type: "placeholder1",
      color: "inherit"
    }, " ", child));
  }));
};

List.propTypes = {
  /** header */
  label: _propTypes["default"].string,
  height: _propTypes["default"].string,

  /** bordered flag */
  bordered: _propTypes["default"].bool,

  /** indication to adjust padding and margin */
  lean: _propTypes["default"].bool
};
List.defaultProps = {
  bordered: false,
  lean: false,
  height: '49px'
};
List.displayName = 'List';

var _default = (0, _context.withVersion)(List);

exports["default"] = _default;